import { useAppState } from "../store/contextProvider";
import { AppActions } from "../store/reducers";
import { Snackbar, Alert, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";

const IAlertBox = () => {
  const { pageState, updateStore } = useAppState();

  const handleClose = (e, reason) => {
    if (reason === "clickaway") return;
    updateStore({ type: AppActions.updatePageState, payload: { showAlert: false } });
  };

  const getIcon = (type) => {
    switch (type) {
      case "success": return <CheckCircleIcon fontSize="large" />;
      case "error": return <ErrorIcon fontSize="large" />;
      case "info": return <InfoIcon fontSize="large" />;
      case "warning": return <WarningIcon fontSize="large" />;
      default: return null;
    }
  };

  return (
    <Snackbar
      open={pageState?.showAlert}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        icon={getIcon(pageState?.alertType)}
        onClose={handleClose}
        severity={pageState?.alertType || "info"}
        sx={{
          width: "400px",
          padding: "20px",
          fontSize: "1.1rem",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography sx={{ flex: 1 }}>{pageState?.alertMessage || ""}</Typography>
      </Alert>
    </Snackbar>
  );
};

export default IAlertBox;
